"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CELL_ACCESS_LABELS = exports.CELL_REACH_LABELS = exports.DEFAULT_PERMISSION_SCOPES = exports.RESTRICTED_TRANSITION_MODULES = exports.RESTRICTED_TRANSITION_LABELS = exports.PERMISSION_OBJECT_MODULES = exports.PERMISSION_AREAS = exports.PERMISSION_OBJECT_COPY = void 0;
exports.isPermissionObjectShown = isPermissionObjectShown;
exports.isRestrictedTransitionShown = isRestrictedTransitionShown;
exports.ownScopeFor = ownScopeFor;
exports.scopeWording = scopeWording;
exports.answersOfCell = answersOfCell;
exports.cellOfAnswers = cellOfAnswers;
exports.reachWording = reachWording;
exports.PERMISSION_OBJECT_COPY = {
    org_unit_position: { label: 'Org chart and positions', description: 'Ventures, departments, teams and the positions in them.' },
    headcount_plan: { label: 'Headcount plan', description: 'How many people each team plans to hire.' },
    requisition: { label: 'Hire requests', description: 'A manager asking for a hire, and turning it into a job.' },
    approval_action: { label: 'Approving', description: 'Saying yes or no on a hire request or an offer.' },
    job_opening: { label: 'Jobs', description: 'The job itself: title, ventures, hiring team, status.' },
    job_config: { label: 'Job setup and interview plans', description: 'Stages, criteria, rounds and who interviews.' },
    posting: { label: 'Job adverts', description: 'Where a job is advertised, and the career site.' },
    candidate: { label: 'Candidates', description: 'The person: CV, contact details, history.' },
    application: { label: 'Candidates on a job', description: 'Where someone stands on one job, and moving them on.' },
    screening_decision: { label: 'Screening decisions', description: 'Yes, maybe or no on a new applicant.' },
    activity_message: { label: 'Messages and notes', description: 'Emails sent to candidates and notes on them.' },
    talent_pool: { label: 'Talent pools', description: 'Groups of people kept for later roles.' },
    assessment_template: { label: 'Tests and the question bank', description: 'Building online tests and their questions.' },
    assessment_attempt: { label: 'Test answers and marks', description: 'What a candidate answered, and the marks.' },
    exam_session: { label: 'Tests in the office', description: 'Tests taken on site, and watching them.' },
    interview: { label: 'Interviews', description: 'Booking, moving and cancelling interviews.' },
    scorecard: { label: 'Scorecards', description: "Each interviewer's marks and notes." },
    stage_decision: { label: 'Stage decisions', description: 'Moving someone on, or rejecting them with a reason.' },
    offer: { label: 'Offers', description: 'Offer letters, amounts and the answer.' },
    reports_own: { label: 'Their own figures', description: 'Their own numbers: jobs, candidates, speed.' },
    reports_all_staff: { label: "Everyone's figures", description: 'Numbers for all staff, including recruiter scoreboards.' },
    admin_config: { label: 'Admin settings', description: 'Everything under Admin except hiring set-up, people and logs.' },
    hiring_setup: {
        label: 'Hiring set-up',
        description: 'Reasons, message templates, pipelines, rubrics, interview plans, calendars, rooms and the staff list.',
    },
    user_management: { label: 'People and roles', description: 'Inviting, deactivating, and this page.' },
    audit_log: { label: 'Access and event logs', description: 'Who signed in, who was refused, what changed.' },
};
exports.PERMISSION_AREAS = [
    { key: 'organisation', label: 'Organisation', objects: ['org_unit_position', 'headcount_plan'] },
    { key: 'hire_requests', label: 'Hire requests', objects: ['requisition', 'approval_action'] },
    { key: 'jobs', label: 'Jobs', objects: ['job_opening', 'job_config', 'posting'] },
    { key: 'candidates', label: 'Candidates', objects: ['candidate', 'application', 'screening_decision', 'activity_message', 'talent_pool'] },
    { key: 'tests', label: 'Tests', objects: ['assessment_template', 'assessment_attempt', 'exam_session'] },
    { key: 'interviews', label: 'Interviews', objects: ['interview', 'scorecard', 'stage_decision'] },
    { key: 'offers', label: 'Offers', objects: ['offer'] },
    { key: 'reports', label: 'Reports', objects: ['reports_own', 'reports_all_staff'] },
    { key: 'admin', label: 'Admin', objects: ['admin_config', 'hiring_setup', 'user_management', 'audit_log'] },
];
// --- Rows that belong to a switchable part (§L28, rule #13) --------------------------------
/**
 * The parts a row belongs to: it shows while **any** of them is on. A row not listed is core and
 * always shows. Approving covers hire requests and offers, so either part brings it back.
 */
exports.PERMISSION_OBJECT_MODULES = {
    org_unit_position: ['organisation'],
    headcount_plan: ['organisation'],
    requisition: ['requisitions'],
    approval_action: ['requisitions', 'offers'],
    posting: ['career_site'],
    talent_pool: ['pools'],
    assessment_template: ['assessments'],
    assessment_attempt: ['assessments'],
    exam_session: ['exam_sessions'],
    offer: ['offers'],
    reports_own: ['reports', 'workspace'],
    reports_all_staff: ['reports'],
};
function isPermissionObjectShown(object, modules) {
    const owners = exports.PERMISSION_OBJECT_MODULES[object];
    return owners === undefined || owners.some((module) => modules[module]);
}
// --- Special actions ------------------------------------------------------------------------
exports.RESTRICTED_TRANSITION_LABELS = {
    skip_pipeline_stage: 'Skip a pipeline stage',
    override_decision_rule: 'Override a decision rule',
    override_critical_criterion: 'Override a critical-criterion block',
    waive_missing_scorecard: 'Waive a missing scorecard',
    reopen_closed_requisition_or_job: 'Reopen a closed requisition or job',
    set_do_not_rehire: 'Mark somebody do-not-rehire',
    merge_candidates: 'Merge two candidate records',
    unmerge_candidates: 'Undo a merge',
    manual_sla_pause: 'Pause a time-limit clock by hand',
    cancel_job_with_active_candidates: 'Cancel a job that still has candidates',
    withdraw_sent_offer: 'Withdraw an offer already sent',
    impersonate_user: 'View the app as somebody else',
};
/** Special actions that belong to a switchable part, hidden like its rows. */
exports.RESTRICTED_TRANSITION_MODULES = {
    manual_sla_pause: ['sla'],
    withdraw_sent_offer: ['offers'],
};
function isRestrictedTransitionShown(transition, modules) {
    const owners = exports.RESTRICTED_TRANSITION_MODULES[transition];
    return owners === undefined || owners.some((module) => modules[module]);
}
// --- "Their own": which own a scoped cell means ----------------------------------------------
/**
 * The scope a row gets when the Admin picks "their own" on a row that has none stored: a blank
 * role's row, or one raised from None or All. The Admin never picks which "own" — it is the
 * stored scope, or this.
 *
 * **Only rows whose "own" the server really narrows by are listed** (review R16, 2026-11-02). The
 * access checks read a cell's scope in exactly these places, and nowhere else:
 * - `requisition` `own_requests` (requisitions.repository `visibleWhere`);
 * - `candidate`, `application`, `activity_message` `own_jobs` (candidate-access, communication-access);
 * - `stage_decision` `own_rounds` (decision-access);
 * - `interview`, `exam_session` `own_only` (interview-access, exam-session-access: the panel or the watcher only).
 * Every other row's reach is the person's own area on People (ventures, departments, "only their own"),
 * so a raised "their own" there would narrow nothing: the editor offers only All and None on it.
 * `role-cells.test.ts` in the API proves each default here narrows.
 */
exports.DEFAULT_PERMISSION_SCOPES = {
    requisition: 'own_requests',
    candidate: 'own_jobs',
    application: 'own_jobs',
    activity_message: 'own_jobs',
    stage_decision: 'own_rounds',
    interview: 'own_only',
    exam_session: 'own_only',
};
/**
 * Which "own" a row means: the scope stored on it, or the row's enforced default. Null when the
 * row has neither, so "their own" is not offered on it.
 */
function ownScopeFor(object, storedScope) {
    return storedScope ?? exports.DEFAULT_PERMISSION_SCOPES[object] ?? null;
}
/** The words for a scope when nothing more specific is written for its row. */
const SCOPE_WORDS = {
    // `own_records` narrows nothing on the cell itself: the person's area on People decides (R16).
    own_records: 'In their area',
    own_org_unit: 'Their own team',
    own_department: 'Their department',
    own_jobs: 'On jobs they lead',
    own_rounds: 'Rounds they lead',
    own_requests: 'Requests they raised',
    assigned_only: 'Ones given to them',
    interviewees_only: 'People they interview',
    own_session: 'Tests they watch',
    own_only: 'Their own',
    contact_details_only: 'Contact details only',
};
/** `object:scope` → words, where the row needs its own. */
const OBJECT_SCOPE_WORDS = {
    'headcount_plan:own_org_unit': "Their own team's plan",
    'requisition:own_records': 'Requests in their area',
    'requisition:own_requests': 'Requests they raised',
    'requisition:assigned_only': 'Requests given to them to approve',
    'approval_action:assigned_only': 'Steps given to them',
    'job_opening:own_department': 'Jobs in their department',
    'posting:own_records': 'Adverts in their area',
    'candidate:own_jobs': 'People on jobs they lead',
    'application:own_jobs': 'People on jobs they lead',
    'talent_pool:own_records': 'Pools in their area',
    'assessment_template:own_records': 'Tests in their area',
    'assessment_attempt:own_jobs': 'On jobs they lead',
    'exam_session:own_only': 'Sessions they watch',
    'job_opening:own_records': 'Jobs in their area',
    'application:own_records': 'People on jobs in their area',
    'interview:own_records': 'Interviews in their area',
    'activity_message:own_records': 'Messages on jobs in their area',
    'interview:own_only': 'Interviews they sit on',
    'scorecard:own_only': 'Their own scorecards',
    'scorecard:own_rounds': 'Rounds they lead',
    'stage_decision:own_rounds': 'Rounds they lead',
    'reports_own:own_records': 'Their own figures',
};
/**
 * `role:object:scope` → words, where one role's "own" reads differently. ADR 0085: the HR
 * assistant reaches the jobs in their area to work the contact list, not jobs they recruit for.
 */
const ROLE_SCOPE_WORDS = {
    'hr_assistant:job_opening:own_records': 'Jobs in their area',
    'hr_assistant:application:own_records': 'People on jobs in their area',
    'hr_assistant:interview:own_records': 'Interviews in their area',
    'hr_assistant:activity_message:own_records': 'Messages on jobs in their area',
};
/**
 * The middle answer of "Which ones can they open?", worded for this row and this role. `roleKey`
 * is the role's own key, or for a copy the standard role it came from (`baseRoleKey`).
 */
function scopeWording(object, scope, roleKey = null) {
    const forRole = roleKey ? ROLE_SCOPE_WORDS[`${roleKey}:${object}:${scope}`] : undefined;
    return forRole ?? OBJECT_SCOPE_WORDS[`${object}:${scope}`] ?? SCOPE_WORDS[scope] ?? 'Their own';
}
exports.CELL_REACH_LABELS = { all: 'All', none: 'None' };
exports.CELL_ACCESS_LABELS = { look: 'Look only', change: 'Change too' };
/**
 * A stored cell as the two answers, truthfully, whatever combination is stored:
 * - `none` → None;
 * - `full`, `read`, or either read-only, with no scope → All · Change too / Look only;
 * - any level with a scope → their own (that scope) · Change too, or Look only when it is `read`
 *   or read-only. So `full` + `own_only` (Invigilator on tests in the office) is "their own ·
 *   change too", `read` + a scope is "their own · look only", and `contact_details_only` reads
 *   "Contact details only" through `scopeWording`;
 * - `scoped` with no scope (never valid; the server refuses it now) → their own, the row's default
 *   (`own_records`, which narrows nothing on the cell, for a row with no enforced default).
 */
function answersOfCell(cell, object) {
    if (cell.level === 'none')
        return { reach: 'none', access: 'look', scope: null };
    const access = cell.level === 'read' || cell.isReadOnly ? 'look' : 'change';
    if (cell.scope !== null)
        return { reach: 'own', access, scope: cell.scope };
    if (cell.level === 'scoped')
        return { reach: 'own', access, scope: ownScopeFor(object, null) ?? 'own_records' };
    return { reach: 'all', access, scope: null };
}
/**
 * The stored cell for the answers. **A row whose answers did not change comes back exactly as
 * stored**, odd combinations included, so saving a role never rewrites a row nobody touched. A
 * changed row is written in the plain form: None `none`; All · Change `full`; All · Look `read`
 * read-only; their own `scoped` with the stored scope (or the row's default) and read-only for Look.
 * `restrictedFields` and anything else on the cell are kept.
 */
function cellOfAnswers(stored, object, answers) {
    const current = answersOfCell(stored, object);
    const isUnchanged = current.reach === answers.reach && (answers.reach === 'none' || current.access === answers.access);
    if (isUnchanged) {
        // The one stored form that cannot be kept: `scoped` with no scope is refused on save.
        return stored.level === 'scoped' && stored.scope === null ? { ...stored, scope: current.scope } : stored;
    }
    switch (answers.reach) {
        case 'none':
            return { ...stored, level: 'none', scope: null, isReadOnly: false };
        case 'all':
            return answers.access === 'change'
                ? { ...stored, level: 'full', scope: null, isReadOnly: false }
                : { ...stored, level: 'read', scope: null, isReadOnly: true };
        case 'own': {
            const scope = current.reach === 'own' ? current.scope : ownScopeFor(object, null);
            // "Their own" is not offered on a row with no enforced default (R16); asked anyway, nothing changes.
            if (scope === null)
                return stored;
            return { ...stored, level: 'scoped', scope, isReadOnly: answers.access === 'look' };
        }
    }
}
/** "Which ones can they open?" in words for a row: All, the worded "own", or None. */
function reachWording(object, answers, roleKey = null) {
    if (answers.reach === 'own')
        return scopeWording(object, answers.scope ?? ownScopeFor(object, null) ?? 'own_records', roleKey);
    return exports.CELL_REACH_LABELS[answers.reach];
}
//# sourceMappingURL=role-cells.js.map